import type { IStudentBadge } from '@/entities/Badges';

export const buildShareText = (badge: IStudentBadge): string =>
  `I earned the "${badge.title}" badge at International Humanitarian College London.`;

export interface ShareTarget {
  id: string;
  label: string;
  /** Готовый адрес формы шаринга площадки. */
  href: (url: string, text: string) => string;
}

/**
 * Формы шаринга площадок. Никаких SDK: обычные ссылки-интенты, они не тянут чужих
 * скриптов и не требуют согласий на трекинг.
 */
export const SHARE_TARGETS: ShareTarget[] = [
  {
    id: 'facebook',
    label: 'Facebook',
    href: (url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
  },
  {
    id: 'x',
    label: 'X',
    href: (url, text) =>
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    href: (url) =>
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
  },
  {
    id: 'telegram',
    label: 'Telegram',
    href: (url, text) =>
      `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    href: (url, text) => `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`,
  },
  {
    id: 'viber',
    label: 'Viber',
    href: (url, text) => `viber://forward?text=${encodeURIComponent(`${text} ${url}`)}`,
  },
  {
    id: 'email',
    label: 'Email',
    href: (url, text) =>
      `mailto:?subject=${encodeURIComponent('My new badge')}&body=${encodeURIComponent(`${text} ${url}`)}`,
  },
];

/**
 * Формы соцсетей открываем вкладкой, а `viber:` и `mailto:` отдаём системе: новая
 * вкладка под них останется висеть пустой.
 */
export const openShareTarget = (href: string): void => {
  if (href.startsWith('http')) {
    window.open(href, '_blank', 'noopener,noreferrer');
    return;
  }

  window.location.href = href;
};
